import { useAuth } from "@/contexts/auth.context";
import { Navigate } from "react-router-dom";

export default function Component() {
  const { userDetails } = useAuth();
  const toUrl =
    userDetails && userDetails?.is_superuser ? "/admin/dashboard" : "/main";
  return <Navigate to={toUrl} replace />;
}
